(function () {
  // 防止同一个页面多次插入相同脚本（多个 section 实例时很常见）
  if (window.__IMAGE_MARQUEE_BOOTED__) return;
  window.__IMAGE_MARQUEE_BOOTED__ = true;

  const STATE = new WeakMap();

  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const px = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };

  const getGap = (el) => {
    const cs = getComputedStyle(el);
    return px(cs.gap || cs.columnGap || '0');
  };

  const waitImages = async (root, timeoutMs = 2500) => {
    const imgs = Array.from(root.querySelectorAll('img'));
    if (!imgs.length) return;

    await Promise.all(
      imgs.map((img) => {
        // 已经有尺寸了就不等
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();

        const done = () => {};
        const loadOrError = new Promise((res) => {
          const finish = () => res();
          img.addEventListener('load', finish, { once: true });
          img.addEventListener('error', finish, { once: true });
        });

        // decode 更稳定（如果支持），失败也不阻塞
        const decodeP =
          img.decode ? img.decode().catch(done) : Promise.resolve();

        // 最终：decode / load / timeout 任意一个结束就继续
        return Promise.race([
          Promise.all([decodeP, loadOrError]).catch(done),
          new Promise((res) => setTimeout(res, timeoutMs))
        ]);
      })
    );
  };

  const makeClone = (group) => {
    const clone = group.cloneNode(true);
    clone.setAttribute('data-marquee-clone', '1');
    clone.setAttribute('aria-hidden', 'true');

    // 避免 tab 一直走到 clone 的链接
    clone.querySelectorAll('a, button, input, textarea, select, [tabindex]').forEach((el) => {
      el.setAttribute('tabindex', '-1');
    });

    return clone;
  };

  const cleanupClones = (inner) => {
    inner.querySelectorAll('[data-marquee-clone="1"]').forEach((n) => n.remove());
  };

  async function measureAndApply(section) {
    if (prefersReduced()) return;

    const inner = section.querySelector('[data-marquee-inner]');
    const group = section.querySelector('[data-marquee-group]');
    const viewport = section.querySelector('.marquee__viewport');
    if (!inner || !group || !viewport) return;

    const st = STATE.get(section) || {};
    if (st.running) return;
    st.running = true;
    STATE.set(section, st);

    // 暂停动画，避免重排时抖动
    inner.style.animationPlayState = 'paused';

    cleanupClones(inner);

    // 等图片尺寸稳定（尤其 auto-width）
    await waitImages(group);

    const speed = Math.max(10, Number(section.dataset.speed || 80));
    const gap = getGap(inner);

    const groupWidth = Math.ceil(group.scrollWidth);
    const viewportWidth = Math.ceil(viewport.clientWidth);

    if (!groupWidth || !viewportWidth) {
      inner.style.animationPlayState = '';
      st.running = false;
      return;
    }

    // shift = 1 组宽度 + 组间 gap
    const shift = groupWidth + gap;

    // 需要的组数量：确保 innerWidth >= viewportWidth + shift
    // innerWidth(m) = m*groupWidth + (m-1)*gap
    // -> m*(groupWidth+gap) >= viewportWidth + groupWidth + 2*gap
    const perGroup = groupWidth + gap;
    const minGroups = Math.min(
      30,
      Math.max(2, Math.ceil((viewportWidth + groupWidth + 2 * gap) / perGroup))
    );

    for (let i = 1; i < minGroups; i++) {
      inner.appendChild(makeClone(group));
    }

    section.style.setProperty('--shift', `${shift}px`);
    const duration = Math.max(2, shift / speed);
    section.style.setProperty('--duration', `${duration.toFixed(2)}s`);

    requestAnimationFrame(() => {
      inner.style.animationPlayState = '';
      st.running = false;
    });
  }

  function schedule(section) {
    const st = STATE.get(section) || {};
    if (st.rafId) cancelAnimationFrame(st.rafId);
    st.rafId = requestAnimationFrame(() => measureAndApply(section));
    STATE.set(section, st);
  }

  function boot(root) {
    root.querySelectorAll('[data-marquee]').forEach((section) => {
      if (!STATE.has(section)) STATE.set(section, { rafId: 0, ro: null, running: false });

      // Resize 自动重算（窗口、横竖屏、Theme Editor 宽度变化都会触发）
      const viewport = section.querySelector('.marquee__viewport');
      const st = STATE.get(section);

      if (viewport && !st.ro && 'ResizeObserver' in window) {
        st.ro = new ResizeObserver(() => schedule(section));
        st.ro.observe(viewport);
      }

      schedule(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => boot(document));

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:select', (e) => boot(e.target));
  document.addEventListener('shopify:block:select', (e) => boot(e.target));

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target;
    root.querySelectorAll('[data-marquee]').forEach((section) => {
      const st = STATE.get(section);
      if (!st) return;
      if (st.rafId) cancelAnimationFrame(st.rafId);
      if (st.ro) st.ro.disconnect();
      STATE.delete(section);
    });
  });
})();